import { Add } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import { s3baseUri } from "../../config/config";

export default function AllImagesModal({
  open,
  handleClose,
  imagesList,
  handleRemoveImage,
  setImagesList,
  uploadImagesOnClick = () => {},
}) {
  useEffect(() => {
    if (open && imagesList.length == 0) {
      handleClose();
    }
  }, [imagesList, open]);

  const [allImagesColorArray, setAllImagesColorArray] = useState([]);

  const getDominantColor = (imageSrc, callback) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src =
      imageSrc?.type === "file"
        ? URL.createObjectURL(imageSrc?.path)
        : imageSrc?.path?.startsWith("data:image")
        ? imageSrc?.path
        : s3baseUri + imageSrc?.thumbnail_1;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0, img.width, img.height);

      const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
      let r = 0,
        g = 0,
        b = 0,
        count = 0;

      for (let i = 0; i < imageData.length; i += 4 * 100) {
        r += imageData[i];
        g += imageData[i + 1];
        b += imageData[i + 2];
        count++;
      }

      // Get average color
      r = Math.floor(r / count);
      g = Math.floor(g / count);
      b = Math.floor(b / count);

      // Blend with white to lighten (70% original color, 30% white)
      const lightenFactor = 0.7;
      r = Math.floor(r * lightenFactor + 255 * (1 - lightenFactor));
      g = Math.floor(g * lightenFactor + 255 * (1 - lightenFactor));
      b = Math.floor(b * lightenFactor + 255 * (1 - lightenFactor));

      callback(`rgb(${r}, ${g}, ${b})`);
    };

    img.onerror = () => {
      callback("#ddd");
    };
  };

  useEffect(() => {
    imagesList.forEach((src, index) => {
      getDominantColor(src, (color) => {
        setAllImagesColorArray((prevColors) => [...prevColors, color]);
      });
    });
  }, [imagesList]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={
          imagesList.length > 6 ? "lg" : imagesList.length > 3 ? "md" : "sm"
        }
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1.28px solid #E7E7E7",
            padding: "8px 18px",
            alignItems: "center",
          }}
        >
          {"All Images"}
          <IconButton
            style={{ backgroundColor: "rgba(145, 158, 171, 0.08)" }}
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon style={{ color: "black", cursor: "pointer" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent className="py-2">
          <div className="row">
            {imagesList.map((file, index) => (
              <div
                className={`col-${
                  imagesList.length > 6 ? "4" : "6"
                } p-1 show-on-hover-parent`}
              >
                <div
                  className="all-image-modal-image-container position-relative"
                  style={{
                    backgroundColor: allImagesColorArray[index] || "#f0f0f0",
                  }}
                >
                  <img
                    src={
                      file?.type === "file"
                        ? URL.createObjectURL(file?.path)
                        : file?.path?.startsWith("data:image")
                        ? file?.path
                        : s3baseUri + file?.thumbnail_1
                    }
                    className="all-image-modal-image"
                  />

                  <div
                    style={{
                      position: "absolute",
                      width: "calc(100% - 8px)",
                      zIndex: "99",
                    }}
                  >
                    <div
                      className="d-flex justify-content-end align-items-start mt-2 px-2"
                      style={{
                        minHeight: "48px",
                      }}
                    >
                      <div>
                        <Tooltip placement="top" title={"Remove Image"}>
                          <IconButton
                            style={{ backgroundColor: "#FFFFFF" }}
                            size="small"
                            color="inherit"
                            onClick={() => {
                              setAllImagesColorArray((prev) => {
                                return prev.filter((clr, i) => i !== index);
                              });
                              handleRemoveImage(index);
                            }}
                          >
                            <CloseIcon
                              style={{ color: "inherit", cursor: "pointer" }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </DialogContent>

        <DialogActions className="border-top py-3 px-3">
          <Button
            size="small"
            variant="outlined"
            startIcon={<Add />}
            onClick={uploadImagesOnClick}
          >
            {"Add Image"}
          </Button>

          <Button variant="contained" size="small" onClick={handleClose}>
            {"Close"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
